import { render, staticRenderFns } from "./popup-group-list.vue?vue&type=template&id=a13aef54&scoped=true"
import script from "./popup-group-list.vue?vue&type=script&lang=js"
export * from "./popup-group-list.vue?vue&type=script&lang=js"
import style0 from "./popup-group-list.vue?vue&type=style&index=0&id=a13aef54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13aef54",
  null
  
)

export default component.exports